/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestownOverviewDto
 */
export interface InvestownOverviewDto {
    /**
     * 
     * @type {Date}
     * @memberof InvestownOverviewDto
     */
    startDate: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    cashSum: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    valueSum: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    assetsCount: number;
    /**
     * 
     * @type {string}
     * @memberof InvestownOverviewDto
     */
    portfolioId: string;
    /**
     * 
     * @type {string}
     * @memberof InvestownOverviewDto
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    interestSum: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    closedInterestSum: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    closedValueSum: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    rewardSum: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownOverviewDto
     */
    feeSum: number;
}

export function InvestownOverviewDtoFromJSON(json: any): InvestownOverviewDto {
    return InvestownOverviewDtoFromJSONTyped(json, false);
}

export function InvestownOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestownOverviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['startDate'])),
        'cashSum': json['cashSum'],
        'valueSum': json['valueSum'],
        'assetsCount': json['assetsCount'],
        'portfolioId': json['portfolioId'],
        'currencyCode': json['currencyCode'],
        'interestSum': json['interestSum'],
        'closedInterestSum': json['closedInterestSum'],
        'closedValueSum': json['closedValueSum'],
        'rewardSum': json['rewardSum'],
        'feeSum': json['feeSum'],
    };
}

export function InvestownOverviewDtoToJSON(value?: InvestownOverviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': (value.startDate.toISOString()),
        'cashSum': value.cashSum,
        'valueSum': value.valueSum,
        'assetsCount': value.assetsCount,
        'portfolioId': value.portfolioId,
        'currencyCode': value.currencyCode,
        'interestSum': value.interestSum,
        'closedInterestSum': value.closedInterestSum,
        'closedValueSum': value.closedValueSum,
        'rewardSum': value.rewardSum,
        'feeSum': value.feeSum,
    };
}

